<div class="p-7 w-[400px] max-w-[90vw]">
  <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] m-0 mb-5">{{dialogTitle}}</p>

  <mat-radio-group [(ngModel)]="selectedOption" class="flex flex-col gap-3 mb-6">
    <mat-radio-button [disabled]="selectedLength === 0" [value]="1">For {{selectedLength}} sample{{selectedLength !== 1 ? 's' : ''}} selected on this page.</mat-radio-button>
    <mat-radio-button [disabled]="totalSamples === 0" [value]="2">For all {{totalSamples}} samples in this Lab Submission.</mat-radio-button>
  </mat-radio-group>

  <div class="flex justify-end gap-3 mt-6">
    <button (click)="closeDialog(false)" class="px-5 py-2.5 rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] transition">Cancel</button>
    <button *ngIf="dialogType === 'add'" (click)="closeDialog(true)" class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--primary-dark)] text-white hover:opacity-90 transition">Add Analysis</button>
    <button *ngIf="dialogType !== 'add'" (click)="closeDialog(true)" class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--notification-error)] text-white hover:opacity-90 transition">{{ dialogType === 'clear' ? 'Clear' : 'Remove' }}</button>
  </div>
</div>
